export default __webpack_public_path__ + "static/gamejam-8bdabfe26af70f0d73292c5b98aa8367.jpeg";